<script setup>
import { computed } from 'vue';
import { useId } from 'vue';

const props = defineProps({
    filled: {
        type: Boolean,
        default: false,
    },
});

const maskId = `intercom-messages-${useId()}`;
const lineFill = computed(() => (props.filled ? '#fff' : 'currentColor'));
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true"
        class="size-6 shrink-0 text-current">
        <mask :id="maskId" fill="#fff">
            <path fill-rule="evenodd"
                d="M19 2a3 3 0 0 1 3 3v15.806c0 1.335-1.613 2.005-2.559 1.062L15.56 18H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3z"
                clip-rule="evenodd" />
        </mask>
        <path fill="currentColor"
            d="m19.441 21.868 1.2-1.204zM15.56 18v-1.7h.702l.498.496zM20.3 5A1.3 1.3 0 0 0 19 3.7V.3A4.7 4.7 0 0 1 23.7 5zm0 8.956V5h3.4v8.956zm0 2.544v-2.544h3.4V16.5zm0 4.306V16.5h3.4v4.306zm.341-.142a.23.23 0 0 0-.218-.043.23.23 0 0 0-.123.185h3.4c0 2.848-3.441 4.277-5.459 2.267zm-3.882-3.868 3.882 3.868-2.4 2.409-3.882-3.869zM5 16.3h10.559v3.4H5zM3.7 15A1.3 1.3 0 0 0 5 16.3v3.4A4.7 4.7 0 0 1 .3 15zm0-10v10H.3V5zM5 3.7A1.3 1.3 0 0 0 3.7 5H.3A4.7 4.7 0 0 1 5 .3zm14 0H5V.3h14z"
            :mask="`url(#${maskId})`" />
        <path :fill="lineFill" fill-rule="evenodd"
            d="M17 7a.85.85 0 0 1 0 1.7H7A.85.85 0 1 1 7 7zm-5 4a.85.85 0 0 1 0 1.7H7A.85.85 0 0 1 7 11z"
            clip-rule="evenodd" />
    </svg>
</template>
